// Parse a "YYYY-MM-DD" birthday and compute the next occurrence, days until it,
// and the age the person will turn. Returns null if the value can't be parsed.
export function birthdayInfo(dob, today = new Date()) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dob || "");
  if (!m) return null;
  const [, y, mo, d] = m.map(Number);
  const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  let next = new Date(t.getFullYear(), mo - 1, d);
  if (next < t) next = new Date(t.getFullYear() + 1, mo - 1, d);
  const daysUntil = Math.round((next - t) / 86400000);
  return { next, daysUntil, turning: next.getFullYear() - y, month: mo, day: d };
}

export function formatBirthday(month, day) {
  return new Date(2000, month - 1, day).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
